import React, { useState } from "react";
import "./App.css";
import NewExpense from "./components/Expenses/NewExpense";
import NewExpenses from "./components/NewExpenses/NewExpenses";

const DUMMY_EXPENSES = [
  {
    id: 1,
    title: "Car insurance",
    amount: 550,
    date: new Date(2021, 6, 10),
  },
  {
    id: 2,
    title: "New TV",
    amount: 12050,
    date: new Date(2021, 11, 15),
  },
  {
    id: 3,
    title: "Medical Aid",
    amount: 1550,
    date: new Date(2021, 2, 22),
  },
  {
    id: 4,
    title: "School Fees",
    amount: 122550,
    date: new Date(2021, 3, 4),
  },
];

function App() {
  const [expenses, setExpenses] = useState(DUMMY_EXPENSES);
 
  const addExpense = (expense) => {
    setExpenses((prevState) => {
      return [expense, ...prevState]
    })
  }
  return (
    <>
      <NewExpenses onAddExpense={addExpense}/>
      <NewExpense expenses={expenses} />
    </>
  );
}

export default App;
